module.exports = __webpack_public_path__ + "media/images/shared/side_menus/icons/bookings-143e84ce12d94426c0af7406f0cb393f.png";